import { CloseButton, Modal } from 'react-bootstrap'
import { redirect } from 'next/navigation'
import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { changeCountItems } from '@/shared/store/slice/cartSlice'
import {
    useGetProductsOrderMutation,
    useGetCartItemsQuery,
} from '@/shared/api-rtk/index.js'
import { useAddProductToCartMutation } from '@/shared/api-rtk/api-list/cartApi'
import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const ModalHistoryOrder = ({ show, onHide, orderId, statusOrder }) => {
    const [products, setProducts] = useState([])
    const [getProducts] = useGetProductsOrderMutation()
    const [addProductToCart] = useAddProductToCartMutation()
    const { data: productsInCart } = useGetCartItemsQuery()
    const iconRef = useRef(null)
    const dispatch = useDispatch()
    const navigate = (path) => redirect(path)

    useEffect(() => {
        getProducts(orderId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setProducts(Object.values(res.data))
                }
            })
    }, [])

    const handleRepeatOrder = async (products) => {
        if (!iconRef.current) return

        // Добавляем класс rotate для запуска анимации
        iconRef.current.classList.add('rotate')

        try {
            // Вызываем функцию добавления товаров в корзину
            await addMultipleItemsToCart(products)

            // Удаляем класс rotate после завершения загрузки
            iconRef.current.classList.remove('rotate')
            navigate(`/cart`)
        } catch (error) {
            console.error('Ошибка при повторении заказа:', error)

            // Удаляем класс rotate в случае ошибки
            iconRef.current.classList.remove('rotate')
            toast.error('Не удалось повторить заказ.')
        }
    }

    const addMultipleItemsToCart = async (products = [], cert = false) => {
        // Проверка, если передан пустой массив товаров
        if (products.length === 0) {
            toast.warn('Нет товаров для добавления в корзину.')
            return
        }

        // Проверка на наличие конфликта с сертификатами
        if (
            (productsInCart?.data.length > 0 && cert) ||
            (productsInCart?.data?.includes('187') && !cert)
        ) {
            toast.warn(
                'Вы можете одновременно заказать либо один Сертификат либо продукцию на нашем сайте.'
            )
            return
        }

        try {
            let totalAdded = 0 // Счётчик добавленных товаров
            let totalSum = 0 // Общая сумма добавленных товаров

            // Последовательное добавление товаров
            for (const product of products) {
                const body = {
                    product_id: product.product_id,
                    quantity: product?.quantity || 1, // По умолчанию количество = 1
                }

                // Отправляем запрос на добавление товара в корзину
                const { data } = await addProductToCart(body)

                // Обновляем счётчики
                if (data) {
                    totalAdded += product?.quantity
                        ? parseInt(product?.quantity)
                        : 1
                    totalSum += product?.quantity
                        ? parseInt(product.price) * parseInt(product.quantity)
                        : 0
                }
            }

            // Обновляем состояние корзины
            dispatch(changeCountItems(totalAdded))
            toast.success(
                `Добавлено товаров: ${totalAdded}. \n Общая сумма: ${totalSum}`
            )
        } catch (error) {
            console.error('Ошибка при добавлении товаров в корзину:', error)
            toast.error('Не удалось добавить товары в корзину.')
        }
    }

    return (
        <Modal
            size="xl"
            show={show}
            onHide={onHide}
            className={'ModalHistoryOrder'}
        >
            <Modal.Header className={'header'}>
                <div className={'text-content'}>
                    <h2>Заказ №{orderId}</h2>
                    <span>{statusOrder}</span>
                </div>
                <div
                    className="action"
                    onClick={() => handleRepeatOrder(products)}
                >
                    <svg
                        ref={iconRef}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-arrow-repeat"
                        viewBox="0 0 16 16"
                    >
                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                        <path
                            fillRule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                        />
                    </svg>
                    <div>Повторить заказ</div>
                </div>
                <CloseButton onClick={onHide} />
            </Modal.Header>
            <Modal.Body className={'content'}>
                {products?.map((product) => {
                    const productId = product.product_id
                    const imageUrl = `${IMAGE_DIR}${product.image}`
                    return (
                        <div
                            className={'product'}
                            onClick={() =>
                                navigate(`/${product.product_keyword}`)
                            }
                            key={productId}
                        >
                            <img src={imageUrl} alt="product-image" />
                            <div className={'about-order'}>
                                <div className={'row-product'}>
                                    <h3>Наименование:</h3>
                                    <p>{product.name}</p>
                                </div>
                                <div className={'row-product'}>
                                    <h3>Количество:</h3>
                                    <p>{product.quantity}</p>
                                </div>
                                <div className={'row-product'}>
                                    <h3>Стоимость:</h3>
                                    <p>{Math.round(Number(product.price))} ₽</p>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Modal.Body>
        </Modal>
    )
}
